module.exports = ".mytimesheet {\n    margin-left: auto;\n    margin-right: auto;\n    width: 95%;\n    margin-top: 25px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/mytimesheet/mytimesheet.component.css
// module id = ./src/app/view/mytimesheet/mytimesheet.component.css
// module chunks = main